import { useEffect, useState } from 'react';

export const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    const fetchData = async () => {
      if (!url) return;
      setIsLoading(true);
      try {
        const res = await fetch(url, { signal });

        if (!res?.ok) {
          const err = new Error('Fetch error');
          err.status = res.status || '00';
          err.statusText = res.statusText || 'Unknown error';
          throw err;
        }

        const json = await res.json();

        if (json?.success && !signal.aborted) {
          setData(json?.data);
          setError(null);
        } else {
          setData(json?.data);
          setError(json?.message);
        }
      } catch (err) {
        if (!signal.aborted) {
          setData(null);
          setError(err);
        }
      } finally {
        if (!signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => abortController.abort();
  }, [url]);

  return { data, error, isLoading };
};
